var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.profileType == 'SCHOLAR')?_c('scholar-profile'):_vm._e(),(
      _vm.$route.params.profileType == 'VENDOR' ||
      _vm.$route.params.profileType == 'TF'
    )?_c('tf-profile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }